import{z as t}from"zod";const e=t.object({redirect_to:t.string(),state:t.string(),code_challenge:t.string()});export{e as AuthorizationCodeInput};
